import { createContext, useState } from "react";
import { resizeImage } from "../helpers";

export const GalleryContext = createContext({
  recentUploads: [],
  getRecentUploads: () => {},
  setUploadedImages: () => {},
});

export function GalleryProvider({ children }) {
  const [recentUploads, setRecentUploads] = useState([
    {
      image_url:
        "https://media.licdn.com/dms/image/v2/D560BAQFenC3M4xVccA/company-logo_200_200/company-logo_200_200/0/1718276133701/yeasitech_logo?e=2147483647&v=beta&t=718w-YBW8UES41HLLueyw_NweT4Rmpm7CTvQkpvazkw",
    },
  ]);

  const getRecentUploads = async () => {
    try {
      // const response = await getUploadedImages();
      // setRecentUploads(response?.data || []);

      const images = JSON.parse(localStorage.getItem("tempImage")) || [];
      setRecentUploads([...recentUploads, ...images]);
    } catch (error) {
      console.error(error);
    }
  };

  // const setUploadedImages = async (file, cb = () => {}) => {

  //   try {
  //     const response = await uploadImage(file);
  //     if (Array.isArray(response)) {
  //       setRecentUploads(response);
  //     }

  //     cb(response?.[0]?.image_url || null);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const setUploadedImages = async (file, cb = () => {}) => {
    try {
      const objectUrl = URL.createObjectURL(file);
      const img = new Image();
      img.src = objectUrl;

      img.onload = async () => {
        try {
          const resizedFile = await resizeImage(img, 1200, 1200, file.name);

          const reader = new FileReader();

          reader.onloadend = () => {
            const base64String = reader.result;

            const images = JSON.parse(localStorage.getItem("tempImage")) || [];

            const updatedImages = [...images, { image_url: base64String }];

            localStorage.setItem("tempImage", JSON.stringify(updatedImages));

            setRecentUploads(updatedImages);

            cb(base64String || null);
          };

          reader.readAsDataURL(resizedFile);
        } catch (err) {
          console.error("Resize failed:", err);
          cb(null);
        } finally {
          URL.revokeObjectURL(objectUrl);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        cb(null);
      };
    } catch (error) {
      console.error("Upload failed:", error);
      cb(null);
    }
  };

  return (
    <GalleryContext.Provider
      value={{
        recentUploads,
        getRecentUploads,
        setUploadedImages,
      }}
    >
      {children}
    </GalleryContext.Provider>
  );
}
